// extracted by mini-css-extract-plugin
export var callCard = "_mi-0";
export var callMessageButton = "_mi-1";
export var helpIcon = "_mi-3";
export var helpIconContainer = "_mi-4";
export var verticalDivider = "_mi-2";